/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { BuiltInCard, BuiltInCard$inboundSchema } from "./builtincard.js";

/**
 * A dashboard Speakeasy ships with the product: its cards are laid out in code and are the same in every project. It is read only; duplicating it makes a project dashboard, with a saved widget per card, that can be changed.
 */
export type BuiltInDashboard = {
  /**
   * Its cards, in no particular order; the grid places them by position
   */
  cards: Array<BuiltInCard>;
  /**
   * What the dashboard is for
   */
  description: string;
  /**
   * Display name
   */
  name: string;
  /**
   * Names the dashboard in links and when duplicating it
   */
  slug: string;
};

/** @internal */
export const BuiltInDashboard$inboundSchema: z.ZodMiniType<
  BuiltInDashboard,
  unknown
> = z.object({
  cards: z.array(BuiltInCard$inboundSchema),
  description: z.string(),
  name: z.string(),
  slug: z.string(),
});

export function builtInDashboardFromJSON(
  jsonString: string,
): SafeParseResult<BuiltInDashboard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BuiltInDashboard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BuiltInDashboard' from JSON`,
  );
}
